export var SelectorType = /*#__PURE__*/function (SelectorType) {
  SelectorType["ENV"] = "env";
  SelectorType["CONFIG"] = "shared config entry";
  return SelectorType;
}(SelectorType || {});